import AppLanguageSwitcher from "../../AppLanguageSwitcher";
import AppNotifications from "../../AppNotifications";
import {
  StyledHeader,
  StyledHeaderLeft,
  StyledHeaderRight,
} from "./index.styled";
import AppThemeSwitch from "@lib/components/AppComponents/AppThemeSwitch";
import HeaderUser from "../components/HeaderUser";
import { useTypedSelector } from "@lib/redux";
import AppLogo from "../components/AppLogo";
import AdminHeaderCollapseMenu from "./AdminHeaderCollapseMenu";
import AdminHeaderLeftMobile from "./AdminHeaderLeftMobile";
import { IRouteConfig } from "@lib/types/Routes";

type Props = {
  routesConfig: IRouteConfig[];
};

const AdminHeader = ({ routesConfig }: Props) => {
  const { header, window } = useTypedSelector((state) => state.screen);
  const breakpointHide = window?.breakpointHide;

  return (
    <StyledHeader height={header?.height}>
      <StyledHeaderLeft mediaWidth={breakpointHide}>
        <AppLogo />
      </StyledHeaderLeft>
      <AdminHeaderLeftMobile routesConfig={routesConfig} />

      {/* <StyledHeaderSearchMinibar
        placeholder={messages["common.searchHere"] as string}
      /> */}

      <StyledHeaderRight>
        <AdminHeaderCollapseMenu />
        <AppThemeSwitch />
        <AppLanguageSwitcher />
        <AppNotifications />
        <HeaderUser />
      </StyledHeaderRight>
    </StyledHeader>
  );
};

export default AdminHeader;
